module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"propDetail\" >\r\n    <div class=\"col-xs-2 nopadding\"><span>Description</span></div>\r\n    <div class=\"col-xs-10\"><input type=\"text\" name=\"description\" value=\"")
    ; __append(escapeFn( description ))
    ; __append("\" /></div>\r\n</div>\r\n")
  }
  return __output;

}